import texture from "./PlaneTexture.js";
import * as THREE from "three";

const geometry = new THREE.PlaneGeometry(2, 2, 2,2);
const material = new THREE.MeshPhongMaterial({ color: 0xffffff, side: 1, wireframe: false });
const plane = new THREE.Mesh(geometry, material);

plane.rotation.x = Math.PI * 0.5;

//resivir sombra
plane.receiveShadow = true;

texture.ground.then((map) => {
    plane.material.map = map;
    plane.material.needsUpdate = true;
    plane.material.map.wrapS = THREE.RepeatWrapping;
    plane.material.map.wrapT = THREE.RepeatWrapping;
    plane.material.map.repeat.set(1, 1);
});


export default plane;